module.exports = __webpack_public_path__ + "img/camera-icon.7a85d220.svg";